import chroma from "chroma-js";
import { useWireAppTheme } from "hooks/use-wireapp-theme";
import tw from "twin.macro";
import { css } from "webapp/styled-components";

interface Props {
    label: string | React.ReactNode;
    details?: string | React.ReactNode;
    checked: boolean;
    onCheck: (val: boolean) => void;
}

export const WireCheckbox: React.VFC<Props> = p => {
    const { label, checked, onCheck, details } = p;

    const className = checked ? "checked" : "unchecked";

    const theme = useWireAppTheme();

    return (
        <label tw="flex items-start">
            <input
                type="checkbox"
                onChange={e => onCheck(e.target.checked)}
                checked={checked}
                tw="mt-0.5 w-4 h-4 rounded flex justify-center items-center mr-2 cursor-pointer transition flex-shrink-0"
                className={className}
                css={css`
                    background-position: center;
                    background-repeat: no-repeat;
                    background-image: url("data:image/svg+xml;utf8, <svg width='10' height='8' viewBox='0 0 10 8' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M3.90042 7.29052C3.613 7.5965 3.14871 7.5965 2.86129 7.29052L0.215564 4.47395C-0.0718547 4.16797 -0.0718547 3.6737 0.215564 3.36772C0.502983 3.06174 0.967274 3.06174 1.25469 3.36772L3.37717 5.62725L8.44753 0.229484C8.73495 -0.0764945 9.19924 -0.0764945 9.48666 0.229484C9.77408 0.535462 9.77408 1.02973 9.48666 1.33571L3.90042 7.29052Z' fill='white' /></svg>");
                    &.checked {
                        ${tw`bg-accent`}
                        box-shadow: 0px 0px 0px 1px rgba(62, 65, 86, 0.2), 0px 0px 0px 1px ${theme.primaryAccentColor};
                    }
                    &.unchecked {
                        ${tw`bg-white`}
                        box-shadow: ${theme.shadowXdark0};
                        :focus-visible {
                            box-shadow: 0px 0px 0px 3px ${chroma(theme.primaryAccentColor).alpha(0.2).css()},
                                0px 0px 0px 1px ${theme.primaryAccentColor};
                        }
                        :hover {
                            box-shadow: 0px 0px 0px 1px ${chroma(theme.n700).alpha(0.36).css()};
                        }
                    }
                `}
            />
            <div>
                <div tw="text-sm text-n700 leading-5">{label}</div>
                {details !== undefined && <div tw="mt-1 text-xs text-n500 leading-4">{details}</div>}
            </div>
        </label>
    );
};
